import { render, staticRenderFns } from "./ProjectDelete.vue?vue&type=template&id=f0683f8c&"
import script from "./ProjectDelete.vue?vue&type=script&lang=js&"
export * from "./ProjectDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports